import { createRouter, createWebHistory } from 'vue-router'
import { isTokenExpired } from "../helpers/jwt-helper";
import { trackMetricaHit } from '../common/metrica-helper';
import store from '../store';
import Home from '../views/Home.vue'
import MyEducation from '../views/Education/MyEducation.vue'
import Excercise from '../views/Excercise/ReadingListening.vue'
import ExercisesHome from '../views/Excercise/Index.vue'
import Test from '../views/Excercise/Test.vue'
import Faq from '../views/Support/Faq.vue'
import LessonSchedule from '../views/Education/LessonSchedule.vue'
import CourseDetailPage from '../views/Courses/Detail.vue'
import BookViewPage from '../views/Courses/BookView.vue'
import Register from '../views/Auth/Register.vue'
import Login from '../views/Auth/Login.vue'
import ForgotPassword from '../views/Auth/ForgotPassword.vue'
import RecoverPassword from '../views/Auth/RecoverPassword.vue'
import NotFound from '../views/NotFound.vue'
import InvitePage from '../views/Account/Invite.vue'
import TrainingFile from '../views/Education/TrainingFile.vue'
import MarketPage from '../views/Market/Market.vue'
import MarketDetailPage from '../views/Market/MarketDetail.vue'
import MarketCheckoutPage from '../views/Market/MarketCheckout.vue'
import MarketCheckoutResultPage from '../views/Market/MarketCheckoutResult.vue'
import MarketSimpleBookPage from '../views/Market/MarketSimpleBook.vue'
import RandomQuestion from '../views/Excercise/RandomQuestion.vue'
import ZoomCallPage from '../views/Education/ZoomCallPage.vue'
//import Posts from '../views/Posts.vue'

const routes = [
  {
    path: '/profile',
    name: 'MyProfile',
    component: () => import('../views/Account/MyProfile.vue'),
    meta: { title: 'Profilim - Lengedu', requiresAuth: true },
  },
  {
    path: '/welcome',
    name: 'Welcome',
    redirect: { name: 'Home' },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/my-education',
    name: 'MyEducation',
    component: MyEducation,
    meta: { title: 'Eğitimim - Lengedu', requiresAuth: true },
  },
  {
    path: '/excercises',
    name: 'Excercise',
    component: ExercisesHome,
    beforeEnter: to => to.query.q ? { name: 'ReadingListening', query: to.query } : true,
    meta: { title: 'Egzersizler - Lengedu', requiresAuth: true },
  },
  {
    path: '/excercises/reading-listening',
    name: 'ReadingListening',
    component: Excercise,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/excercises/tests',
    name: 'Test',
    component: Test,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/invite',
    name: 'Invite',
    component: InvitePage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/zoom-call',
    name: 'ZoomCallPage',
    component: ZoomCallPage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/training',
    name: 'Training',
    component: TrainingFile,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/excercises/random-question-generator',
    name: 'RandomQuestion',
    component: RandomQuestion,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/market',
    name: 'Market',
    component: MarketPage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/market/detail/:id',
    name: 'MarketDetail',
    component: MarketDetailPage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/market/checkout/:catid/:id',
    name: 'MarketCheckoutPage',
    component: MarketCheckoutPage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/market/checkout/result/',
    name: 'MarketCheckoutResultPage',
    component: MarketCheckoutResultPage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/market/simplebook/',
    name: 'MarketSimpleBookPage',
    component: MarketSimpleBookPage,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',requiresAuth: true},
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    meta: { title: 'Sıkça Sorulan Sorular - Lengedu', requiresAuth: true }
  },
  
  {
    path: '/lesson-schedule',
    name: 'LessonSchedule',
    component: LessonSchedule,
    meta: {requiresAuth: true},
  },
 {
    path: '/courses/:unit/:id',
    name: 'CourseDetail',
    component: CourseDetailPage,
    meta: {requiresAuth: true},
  },
  {
    path: '/bookview/:url',
    name: 'BookView',
    component: BookViewPage,
    meta: {requiresAuth: true},
  },
  {
    path: '/register',
    name: "RegisterPage",
    component: Register,
    meta: { title:'Lengedu İngilizce Eğitim Platformu', guest: true },
  },
  {
    path: '/login',
    name: "LoginPage",
    component: Login,
    meta: {title:'Lengedu İngilizce Eğitim Platformu',  guest: true },
  },
  {
    path: '/forgot-password',
    name: "ForgotPasswordPage",
    component: ForgotPassword,
    meta: { title:'Lengedu İngilizce Eğitim Platformu', guest: true },
  },
  {
    path: '/recover-password/:code',
    name: "RecoverPasswordPage",
    component: RecoverPassword,
    meta: { title:'Lengedu İngilizce Eğitim Platformu', guest: true },
  },
  {
    path: "/:notFound",
    name: "NotFoundPage",
    component: NotFound,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { left: 0, top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const title = to.meta.title
  if (title) {
    document.title = title
  }

  let isAuthenticated = store.getters.isAuthenticated;

  if (isAuthenticated) {
    const user = store.getters.StateUser;
    if (user && isTokenExpired(user.token)) {
      try {
        await store.dispatch("RefreshToken");
        isAuthenticated = true;
      } catch (err) {
        await store.dispatch("LogOut", false);
        isAuthenticated = false;
      }
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      next();
      return;
    }
    next('/login');
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (isAuthenticated && AnyLoginPages(to.matched[0].name)) {
      next('/');
    }else{  
      next();
    }
  }
  else {
    next();
  }
});

router.afterEach((to) => {
  trackMetricaHit(to.fullPath, to.meta.title || document.title);
});

function AnyLoginPages(pageName){
  const loginPages=["LoginPage","RegisterPage","ForgotPasswordPage","RecoverPasswordPage"];
  let result = false;
  if(loginPages.find(x=>x===pageName)){
    result=true;
  }
  return result;
}

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.guest)) {
//     if (store.getters.isAuthenticated) {
//       next("/posts");
//       return;
//     }
//     next();
//   } else {
//     next();
//   }
// });

export default router
